const prefix = "[TEMPLATES_OVERVIEW]";

export default {
    FETCH_TEMPLATE_DETAILS_REQUEST: `${prefix} FETCH_TEMPLATE_DETAILS_REQUEST`,
    FETCH_TEMPLATE_DETAILS_SUCCESS: `${prefix} FETCH_TEMPLATE_DETAILS_SUCCESS`,
    FETCH_TEMPLATE_DETAILS_FAILED: `${prefix} FETCH_TEMPLATE_DETAILS_FAILED`,
    CREATE_TEMPLATE_REQUEST: `${prefix} CREATE_TEMPLATE_REQUEST`,
    CREATE_TEMPLATE_SUCCESS: `${prefix} CREATE_TEMPLATE_SUCCESS`,
    CREATE_TEMPLATE_FAILED: `${prefix} CREATE_TEMPLATE_FAILED`,
    UPDATE_TEMPLATE_REQUEST: `${prefix} UPDATE_TEMPLATE_REQUEST`,
    UPDATE_TEMPLATE_SUCCESS: `${prefix} UPDATE_TEMPLATE_SUCCESS`,
    UPDATE_TEMPLATE_FAILED: `${prefix} UPDATE_TEMPLATE_FAILED`,
    VALIDATE_TEMPLATE_REQUEST: `${prefix} VALIDATE_TEMPLATE_REQUEST`,
    VALIDATE_TEMPLATE_SUCCESS: `${prefix} VALIDATE_TEMPLATE_SUCCESS`,
    VALIDATE_TEMPLATE_FAILED: `${prefix} VALIDATE_TEMPLATE_FAILED`,
    CLAEAR_TEMPLATE_DEFINITION: `${prefix} CLAEAR_TEMPLATE_DEFINITION`,
};
